import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'

class AdminSearchCoupon extends Component {

	constructor(props){
    super(props);
    this.state={
      data: {
      	couponName: '',
        searchTerm:'',
        couponDetails: '',
        couponErrMsg: ''
      },
      componentToShow: true,
      errorMsg: ''
    }
  }

	onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleSearchQuery = (e) => {
    e.preventDefault()
    this.fetchSearchResults() 
  }

  handleClear = (e) => {
    e.preventDefault()
    const data = Object.assign({}, this.state.data);
    data.searchTerm =''
    data.couponDetails =''
    this.setState({data:data,componentToShow: true})
    
  }

  fetchSearchResults = () => {
    let data = Object.assign({}, this.state.data)

    if(data.searchTerm === '') {
      data.couponDetails =''
      this.setState({errorMsg: 'Please enter the search term', data:data})
      return
    }

    let errorMsg = ''
    let apiInput = {
      'name': data.searchTerm,
    }
    api.adminSearchCoupons(this.props.user.accessToken, apiInput).then((result) => {
      const { status, errors} = result
      if (status === 'success') {
        if(result.data) {
          data.couponDetails = result.data
        }
        else if (result.message){
          data.couponErrMsg = result.message
        }
      }
      this.setState({data:data, errorMsg: errorMsg})
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  } 

  handleDisplay = () => {
    this.setState({componentToShow: false})
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

	render() {
		let searchComponent,displayComponent;
    searchComponent = (
      <div>
        <Typography className="admin-reg-filter-section">
          Coupon Name:
        </Typography>
        <TextField  className='admin-reg-filter-criteria' label="Search Coupon" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.data.searchTerm}/>
        <Button className="add-opportunity" onClick={this.handleSearchQuery}>
          Search
        </Button>
        <Button className="add-opportunity" onClick={this.handleClear}>
          Clear
        </Button>
        <br/><br/>
      </div>
    )

    let coupon;
    if(this.state.data.couponDetails.length !== 0){
      coupon = this.state.data.couponDetails
      displayComponent = (
        <div>
          <Grid>
            <GridCell span="6" align="left">
              <Typography><b>Coupon Name:</b> {coupon[0].coupon_name}</Typography>
            </GridCell>
            <GridCell span="6">
              <Typography><b>Test Track name:</b>{coupon[0].tq_test_track_name}</Typography>
            </GridCell>
            <GridCell span="6">
              <Typography><b>Total Count:</b>{coupon[0].total_count}</Typography>
            </GridCell>
            <GridCell span="6">
              <Typography><b>Remaining Count:</b>{coupon[0].remaining_count}</Typography>
            </GridCell>
            <GridCell span="6">
              <Button onClick={this.handleDisplay}>Update</Button>
            </GridCell>
          </Grid>
        </div>
      )
    }

    else if(this.state.data.couponDetails !== ""){
      displayComponent = (
        <div>
          <StatusMessage error_msg = "No Coupons found."/>
        </div>
      )
    }

    let componentToShow;
    if(this.state.componentToShow) {
      componentToShow = (
        <div>
          <Grid>
            <GridCell span="10"><Typography use="headline6">Search Coupons</Typography></GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          {searchComponent}
          <Card>{displayComponent}</Card>
        </div>
      )
    }
    else{
      componentToShow = (<AdminUpdateCoupon couponDetails = {this.state.data.couponDetails[0]} accessToken = {this.props.user.accessToken}/>)
    }

    return (
      <div>
        {componentToShow}
        <StatusMessage error_msg = {this.state.errorMsg}/>
      </div>
    );
  }
}

class AdminUpdateCoupon extends Component {

  constructor(props){
    super(props);
    this.state={
      data: {
       couponName: '',
       trackName: '',
       totalCount: '',
       remainingCount: '',
       incrementCount: '',
       buttonDisabled: false
      },
      formErrors: {
        'incrementCountError':'',
      },
      errorMsg: ''
    }
  }

  componentDidMount() {
    const data = Object.assign({}, this.state.data);
    data.couponName = this.props.couponDetails.coupon_name
    data.trackName = this.props.couponDetails.tq_test_track_name
    data.totalCount = this.props.couponDetails.total_count
    data.remainingCount = this.props.couponDetails.remaining_count
    this.setState({data: data})
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.incrementCountError = ''


    if(data.incrementCount === '' || data.incrementCount === undefined){
        errorObj.incrementCountError ='Add Coupon count is mandatory'
        error = false
      }

    if(data.incrementCount <= 0){
        errorObj.incrementCountError = 'Coupon count must be greater than 0'
        error = false
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
      })
      return error
  }

  updateCoupon = (e) => {
    e.preventDefault()
    this.setState({buttonDisabled: true})
    let data = Object.assign({}, this.state.data)

    if(this.validateForm()){
      let apiInput = {
        'add_coupon_count': parseInt(data.incrementCount)
      }
      
       api.adminUpdateCoupons(this.props.accessToken,apiInput,this.props.couponDetails.coupon_id)
      .then((result) => {     
        if(result.errors){
          this.setState({ errorMsg: result.errors,buttonDisabled: false })
        }
        else{
          this.setState({errorMsg: result.message, buttonDisabled: true})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
    else{
      this.setState({buttonDisabled: false})
    }
  }
  
  render(){
    return (
      <form onSubmit={(e) => this.updateCoupon(e)} style={{width: '100%'}}>
        <Card style={{padding: '25px'}}>
          <Grid>
            <GridCell span="12"><Typography use="headline5">Update Coupon</Typography></GridCell>
          </Grid>
          <Grid className="opportunity-list-item">
            <GridCell span="6">
              <TextField fullwidth disabled className='text_input' label="Coupon Name" autoComplete="off" name="couponName" onChange={this.onInputChange} value={this.state.data.couponName}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">                  
              <TextField fullwidth disabled className='text_input' label="Track Name" autoComplete="off"  name="trackName" onChange={this.onInputChange} value={this.state.data.trackName}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <TextField fullwidth disabled className='text_input' label="Total Count" autoComplete="off"  name="totalCount" onChange={this.onInputChange} value={this.state.data.totalCount}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <TextField fullwidth disabled className='text_input' label="Remaining Count" autoComplete="off"  name="remainingCount" onChange={this.onInputChange} value={this.state.data.remainingCount}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <TextField fullwidth className='text_input' type='number' label="Add Coupon Count" autoComplete="off"  name="incrementCount" onChange={this.onInputChange} value={this.state.data.incrementCount}/>
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              <Button disabled={this.state.buttonDisabled} raised>Update</Button>
            </GridCell> 
          </Grid>
          <StatusMessage error_msg = {this.state.errorMsg}/>
          <StatusMessage error_msg = {this.state.formErrors.incrementCountError}/>
        </Card>
      </form>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSearchCoupon);


// WEBPACK FOOTER //
// ./src/views/admin/AdminSearchCoupon.jsx